/**
 * Utility function for merging CSS class names
 * Combines clsx for conditional classes with tailwind-merge for deduplication
 */

type ClassValue = string | number | boolean | undefined | null | ClassValue[];

/**
 * Combines multiple class values into a single string
 * Handles conditional classes, arrays, and falsy values
 */
export function cn(...inputs: ClassValue[]): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === 'string') {
      classes.push(input);
    } else if (typeof input === 'number') {
      classes.push(String(input));
    } else if (Array.isArray(input)) {
      const nested = cn(...input);
      if (nested) {
        classes.push(nested);
      }
    }
  }

  return classes.join(' ');
}

/**
 * Conditional class builder
 * Takes an object where keys are class names and values are boolean conditions
 */
export function cx(
  classMap: Record<string, boolean | undefined | null>
): string {
  const classes: string[] = [];

  for (const [className, condition] of Object.entries(classMap)) {
    if (condition) {
      classes.push(className);
    }
  }

  return classes.join(' ');
}
